module.exports = __webpack_public_path__ + "static/testimonial1-18aa6fa87090ddedaae12f7c8c5deb5e.png";